import { module } from 'angular';

import { Custom, Synthetic } from './';
import { default as skillViewServiceName, SkillViewService } from './skill-view.service';

export default module('hypervision.skill-view', [Custom, Synthetic])
  .constant('SKILL_METRIC_NAMES', [
    {
      label: 'nbPresentCsrs',
      name: 'SUM_CSR_PRESENT_SKILL_NOW',
      incomingPhoneName: 'SUM_CSR_PRESENT_SKILL_NOW',
      outgoingPhoneName: 'SUM_CSR_PRESENT_SKILL_NOW',
      mailName: 'SUM_CSR_PRESENT_SKILL_NOW',
      chatIadvizeName: 'SUM_CSR_PRESENT_SKILL_NOW',
    },
    {
      label: 'nbAvailableCsrs',
      name: 'SUM_CSR_AVAILABLE_SKILL_NOW',
      incomingPhoneName: 'SUM_CSR_AVAILABLE_PHONE_INCOMING_SKILL_NOW',
      outgoingPhoneName: 'SUM_CSR_AVAILABLE_PHONE_OUTGOING_SKILL_NOW',
      mailName: 'SUM_CSR_AVAILABLE_MAIL_INCOMING_SKILL_NOW',
      chatIadvizeName: undefined,
    },
    {
      label: 'nbWorkingCsrs',
      name: 'SUM_CSR_WORKING_SKILL_NOW',
      incomingPhoneName: 'SUM_CSR_WORKING_PHONE_INCOMING_SKILL_NOW',
      outgoingPhoneName: 'SUM_CSR_WORKING_PHONE_OUTGOING_SKILL_NOW',
      mailName: 'SUM_CSR_WORKING_MAIL_INCOMING_SKILL_NOW',
      chatIadvizeName: undefined,
    },
    {
      label: 'waitingContactNb',
      name: 'SUM_CTT_CREATED_SKILL_NOW',
      incomingPhoneName: 'SUM_CTT_CREATED_PHONE_INCOMING_SKILL_NOW',
      outgoingPhoneName: 'SUM_CTT_CREATED_PHONE_OUTGOING_SKILL_NOW',
      mailName: 'SUM_CTT_CREATED_MAIL_INCOMING_SKILL_NOW',
      chatIadvizeName: undefined,
    },
    {
      label: 'nbNotProcessedContacts',
      name: 'SUM_CTT_NOT_PROCESSED_SKILL',
      incomingPhoneName: 'SUM_CTT_NOT_PROCESSED_PHONE_INCOMING_SKILL',
      outgoingPhoneName: 'SUM_CTT_NOT_PROCESSED_PHONE_OUTGOING_SKILL',
      mailName: 'SUM_CTT_NOT_PROCESSED_MAIL_INCOMING_SKILL',
      chatIadvizeName: undefined,
    },
    {
      label: 'nbProcessedContacts',
      name: 'SUM_CTT_SUCCESS_SKILL',
      incomingPhoneName: 'SUM_CTT_SUCCESS_PHONE_INCOMING_SKILL',
      outgoingPhoneName: 'SUM_CTT_SUCCESS_PHONE_OUTGOING_SKILL',
      mailName: 'SUM_CTT_SUCCESS_MAIL_INCOMING_SKILL',
      chatIadvizeName: undefined,
    },
    {
      label: 'nbGaveUpContacts',
      name: 'SUM_CTT_GAVE_UP_SKILL',
      incomingPhoneName: undefined,
      outgoingPhoneName: undefined,
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'nbPresentedContacts',
      name: 'SUM_CTT_CREATED_SKILL',
      incomingPhoneName: 'SUM_CTT_CREATED_PHONE_INCOMING_SKILL',
      outgoingPhoneName: undefined,
      mailName: 'SUM_CTT_CREATED_MAIL_INCOMING_SKILL',
      chatIadvizeName: undefined,
    },
    {
      label: 'treatmentTime',
      name: 'TA_CTT_CALL_DURATION_SKILL',
      incomingPhoneName: undefined,
      outgoingPhoneName: undefined,
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'rateContactProcessed',
      name: 'RATE_CTT_PROCESSED_SKILL',
      incomingPhoneName: undefined,
      outgoingPhoneName: undefined,
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'rateContactProcessedInLessThan20s',
      name: 'RATE_CTT_PROCESSED_IN_LESS_THAN_20S_SKILL',
      incomingPhoneName: undefined,
      outgoingPhoneName: undefined,
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'rateContactProcessedInLessThan90s',
      name: 'RATE_CTT_PROCESSED_IN_LESS_THAN_90S_SKILL',
      incomingPhoneName: undefined,
      outgoingPhoneName: undefined,
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'nbTransferredContacts',
      name: 'SUM_CTT_TRANSFERRED_SKILL',
      incomingPhoneName: undefined, // "SUM_CONTACT_TRANSFERRED_PHONE_INCOMING",
      outgoingPhoneName: undefined, // "SUM_CONTACT_TRANSFERRED_PHONE_OUTGOING",
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'nbForwardedContacts',
      name: 'SUM_CTT_REDIRECTED_SKILL',
      incomingPhoneName: undefined,
      outgoingPhoneName: undefined,
      mailName: undefined,
      chatIadvizeName: undefined,
    },
    {
      label: 'nbScriptAnchorRedirect',
      name: 'SUM_SCRIPT_ANCHOR_REDIRECTION_SKILL',
      incomingPhoneName: undefined, // "SUM_CONTACT_REDIRECTED_PHONE_INCOMING",
      outgoingPhoneName: undefined, // "SUM_CONTACT_REDIRECTED_PHONE_OUTGOING",
      mailName: undefined, // "SUM_CONTACT_REDIRECTED_MAIL_INCOMING",
      chatIadvizeName: undefined,
    },
  ])
  .service(skillViewServiceName, SkillViewService).name;
